import Label from '@cbgms/components/form/Label'

export default Label
